import React, { useMemo, forwardRef } from "react";

import SidebarItem from "./SidebarItem";
import ImageLoader from "../../common/ImageLoader";
import { CURRENCY_SIGN } from "../../../../shared/enums";
import { filterRegionSpecificPrices } from "../../../static-data";

// import milaAir3 from "assets/images/landingAir/mila-air-3-alt.jpg";
// import milaAir3Webp from "assets/images/landingAir/mila-air-3-alt.jpg?as=webp";

import milaAirMini from "assets/images/landingAir/mila-air-mini.jpg";
import milaAirMiniWebp from "assets/images/landingAir/mila-air-mini.jpg?as=webp";

import accessory01 from "assets/images/landingAir/accessory-img-01.jpg";
import accessory01Webp from "assets/images/landingAir/accessory-img-01.jpg?as=webp";

import accessory03 from "assets/images/landingAir/accessory-img-03.jpg";
import accessory03Webp from "assets/images/landingAir/accessory-img-03.jpg?as=webp";

const SidebarMenu = forwardRef(({ regional }, ref) => {
  const { air, airMini, milaFilter, milaSocks } =
    filterRegionSpecificPrices[regional];

  const sidebarContent = useMemo(() => {
    return (
      <div className="header__sidebar order-list" ref={ref}>
        <SidebarItem title="Choose your Mila">
          <div className="mila-list">
            {/* <div className="mila-item">
              <ImageLoader
                className="mila-item__image img-relative"
                placeholderAspectRatio={1 / 1}
                image={milaAir3}
                webp={milaAir3Webp}
                alt={"Mila Air"}
              />
              <div className="mila-item__content">
                <div className="mila-item__heading">
                  <h3 className="mila-item__title">Mila Air 3</h3>
                  <p className="mila-item__price">
                    Starting at £{air.base}
                    <span>with Auto-Refill</span>
                  </p>
                </div>
                <a
                  href="https://milacares.com/buy"
                  className="button button--primary button--sm"
                >
                  Buy now
                </a>
              </div>
            </div> */}
            <div className="mila-item">
              <ImageLoader
                className="mila-item__image img-relative"
                placeholderAspectRatio={1 / 1}
                image={milaAirMini}
                webp={milaAirMiniWebp}
                alt={"Mila Air Mini"}
              />
              <div className="mila-item__content">
                <div className="mila-item__heading">
                  <h3 className="mila-item__title">Mila Air Mini</h3>
                  <p className="mila-item__price">
                    Starting at {CURRENCY_SIGN[regional]}
                    {airMini.base}{" "}
                    {airMini.del && (
                      <del>
                        {CURRENCY_SIGN[regional]}
                        {airMini.del}
                      </del>
                    )}
                    <span>with Auto-Refill</span>
                  </p>
                </div>
                <a
                  href="https://airmini.milacares.com/"
                  className="button button--primary button--sm"
                >
                  Buy now
                </a>
              </div>
            </div>
          </div>
        </SidebarItem>

        <SidebarItem title="Buy accessories">
          <div className="mila-list">
            <div className="mila-item mila-item--filter">
              <ImageLoader
                className="mila-item__image img-relative"
                placeholderAspectRatio={1 / 1}
                image={accessory01}
                webp={accessory01Webp}
                alt={"Mila Air Filters"}
              />
              <div className="mila-item__content">
                <div className="mila-item__heading">
                  <h3 className="mila-item__title">Mila Air Filter</h3>
                  <p className="mila-item__price">
                    Starting at {CURRENCY_SIGN[regional]}
                    {milaFilter.base}{" "}
                    {milaFilter.del && (
                      <del>
                        {CURRENCY_SIGN[regional]}
                        {milaFilter.del}
                      </del>
                    )}
                  </p>
                  {/* <button
                      type="button"
                      className="button button--white button--sm button--shadow-dark"
                    >
                      Filter type <IconAngleDown />
                    </button> */}
                </div>
                <a
                  href="https://shop.milacares.com/filters"
                  className="button button--primary button--sm"
                >
                  Buy now
                </a>
              </div>
            </div>

            <div className="mila-item mila-item--filter">
              <ImageLoader
                className="mila-item__image img-relative"
                placeholderAspectRatio={1 / 1}
                image={accessory03}
                webp={accessory03Webp}
                alt={"Mila Air Socks"}
              />
              <div className="mila-item__content">
                <div className="mila-item__heading">
                  <h3 className="mila-item__title">Mila Socks (5 pack)</h3>
                  <p className="mila-item__price">
                    {CURRENCY_SIGN[regional]}
                    {milaSocks.base}{" "}
                    {milaSocks.del && (
                      <del>
                        {CURRENCY_SIGN[regional]}
                        {milaSocks.del}
                      </del>
                    )}
                  </p>
                </div>
                <a
                  href="https://milacares.com/buy"
                  className="button button--primary button--sm"
                >
                  Buy now
                </a>
              </div>
            </div>
          </div>
        </SidebarItem>
      </div>
    );
  }, [air, airMini, milaFilter, milaSocks]);

  return sidebarContent;
});

export default SidebarMenu;
